import { render, staticRenderFns } from "./AddExitRegister.vue?vue&type=template&id=081253bf&scoped=true"
import script from "./AddExitRegister.vue?vue&type=script&lang=js"
export * from "./AddExitRegister.vue?vue&type=script&lang=js"
import style0 from "./AddExitRegister.vue?vue&type=style&index=0&id=081253bf&prod&scoped=true&lang=css"
import style1 from "./AddExitRegister.vue?vue&type=style&index=1&id=081253bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081253bf",
  null
  
)

export default component.exports